import React, { ChangeEvent, useState } from "react";
import InputField from "../../../../components/common/form/InputField";
import NumberFormat from "react-number-format";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import clsx from "clsx";

interface Props {
    curAccount: any;
    setCertificate: any;
    showAccount: number;
    setIsSavedResult?: any;
    stateList?: any;
    countyList?: any;
    getCountyByStateIdApi?: any;
    setReset?: any;
    similarAccountList?: any;
    setSimilarAccountList?: any;
    editable?: boolean;
    isEmptyState?: any;
    setIsEmptyState?: any;
    isEmptyCounty?: any;
    setIsEmptyCounty?: any;
    setUpdatedAccountIndexList?: any;
}

export function PropertyInfoSection({
    curAccount,
    setCertificate,
    showAccount,
    setIsSavedResult,
    stateList,
    countyList,
    getCountyByStateIdApi,
    setReset,
    similarAccountList,
    setSimilarAccountList,
    editable,
    isEmptyState,
    setIsEmptyState,
    isEmptyCounty,
    setIsEmptyCounty,
    setUpdatedAccountIndexList
}: Props) {
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [disable, setDisable] = useState(false);
    const [changeField, setChangeField] = useState("");
    const [stateId, setStateId] = useState("");
    const [countyId, setCountyId] = useState("");

    const updateCertificateAccountField = (fieldName: any, value: any) => {
        setCertificate((prevCert: any) => {
            const updatedAccounts = [...prevCert.accounts];
            updatedAccounts[showAccount] = {
                ...updatedAccounts[showAccount],
                [fieldName]: value,
                taxDataSource: 'EDITOR',
                ...(fieldName === 'stateId' && { countyId: '' }), // Reset countyId if stateId is updated
            };

            // Update propertyIds for accountNumber
            const updatedPropertyIds = [...prevCert.propertyIds];
            if (fieldName === 'accountNumber') {
                updatedPropertyIds[showAccount] = {
                    id: value,
                    visibility: true,
                };
            }

            return {
                ...prevCert,
                accounts: updatedAccounts,
                propertyIds: updatedPropertyIds,
                ...(fieldName === 'accountNumber' && { propertyIds: updatedPropertyIds }),
            };
        });

        if (fieldName === 'accountNumber' && similarAccountList && setSimilarAccountList) {
            const filtered = similarAccountList.filter(
                (el: any) => el.accountNumber !== curAccount[fieldName]
            );
            setSimilarAccountList(filtered);
        }

        setIsSavedResult(false);
        setUpdatedAccountIndexList((prev: any) => {
            if (!prev.includes(showAccount)) {
                return [...prev, showAccount];
            }
            return prev;
        });
    };



    function updateData(e: any) {
        e.preventDefault();

        const updatedAccount = {
            ...curAccount,
            taxDataSource: 'EDITOR',
            stateId: changeField === 'stateId' ? stateId : curAccount.stateId,
            countyId: changeField !== 'stateId' ? countyId : curAccount.countyId,
            accountNumber: curAccount.accountNumber.replace(`-${curAccount.associationName}`, ''),
        };

        if (changeField === 'stateId') {
            getCountyByStateIdApi(stateId);
        }

        // Update certificate state immutably
        setCertificate((prevCert: any) => {
            const updatedAccounts = [...prevCert.accounts];
            updatedAccounts[showAccount] = updatedAccount;

            const updatedPropertyIds = [...(prevCert.propertyIds || [])];
            updatedPropertyIds[showAccount] = {
                id: updatedAccount.accountNumber,
                visibility: true,
            };

            return {
                ...prevCert,
                accounts: updatedAccounts,
                propertyIds: updatedPropertyIds,
            };
        });

        // Final state updates
        setDisable(false);
        setChangeField('');
        setConfirmationModal(false);
        setIsSavedResult(false);
        setUpdatedAccountIndexList((prev: any) => {
            if (!prev.includes(showAccount)) {
                return [...prev, showAccount];
            }
            return prev;
        });
        setReset(true);
    }

    return (
        <>
            <div className="col-lg-6 col-sm-12 pr-0">
                <div className="border border-solid border-text-4 bg-highlight-1 text-[white] p-2   ">
                    <b className="weight_data">Property Information</b>
                </div>
                <div className="border border-solid border-text-4">
                    <table
                        className="scroll1 tax-table text-sm w-full [&_td]:border [&_td]:border-surface-5 p-[6px] text-left">
                        <tbody>
                            <tr>
                                <td className="pl-3">Address</td>
                                <td style={{ position: "relative" }}>
                                    <input
                                        placeholder="..."
                                        className={clsx(
                                            'border-3 border-surface-5 text-surface-3 rounded-md p-2',
                                            'w-[100%]',
                                            !editable
                                                ? 'cursor-text  bg-surface-5 text-surface-3'
                                                : 'text-sm'
                                        )}
                                        value={curAccount?.situsAddress || ''}
                                        onChange={(e) =>
                                            updateCertificateAccountField('situsAddress', e.target.value)
                                        }
                                        type="text"
                                        readOnly={!editable}
                                    />


                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">Legal</td>
                                <td>
                                    <InputField
                                        placeholder="..."
                                        value={curAccount?.legalDescription || ""}
                                        type="text"
                                        disabled={!editable}
                                        hideLabel
                                        onChange={(e) => {
                                            updateCertificateAccountField('legalDescription', e.target.value)

                                        }}
                                    />


                                </td>
                            </tr>
                            <tr>
                                <td className="">Subdivision Name</td>
                                <td>
                                    <InputField
                                        placeholder="..."
                                        value={curAccount?.propertySubdivision || ""}
                                        type="text"
                                        disabled={true}
                                        hideLabel
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">Subdivision Code</td>
                                <td>
                                    <InputField
                                        placeholder="..."
                                        value={curAccount?.subdivisionCode || ""}
                                        type="text"
                                        disabled={true}
                                        hideLabel
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">Tax Id</td>
                                <td style={{ position: "relative" }}>
                                    <input
                                        placeholder="..."
                                        className={clsx(
                                            'border-3 border-surface-5 text-surface-3 rounded-md p-2',
                                            'w-[100%]',
                                            !editable
                                                ? 'cursor-text bg-surface-5 text-surface-3'
                                                : 'text-sm'
                                        )}
                                        value={curAccount?.["accountNumber"] ?? ''}
                                        onChange={(e) => updateCertificateAccountField("accountNumber", e.target.value)}
                                        type="text"
                                        readOnly={!editable}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">Acreage</td>
                                <td>
                                    <NumberFormat
                                        placeholder="..."
                                        className={clsx(
                                            'border-3 border-surface-5 text-surface-3 rounded-md  p-2',
                                            'w-[100%]',
                                            !editable
                                                ? ' cursor-text bg-surface-5 text-surface-3'
                                                : 'text-sm   ',
                                        )}
                                        decimalScale={4}
                                        decimalSeparator="."
                                        fixedDecimalScale
                                        value={curAccount?.acreage || ""}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                            updateCertificateAccountField('acreage', e.target.value.replaceAll(",", ""))
                                        }}
                                        readOnly={!editable}
                                        thousandSeparator={true}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">State</td>
                                <td>

                                    <select
                                        className={isEmptyState ? "border border-3 border-error-2 p-2 rounded-md text-surface-3 w-[100%]" : clsx(
                                            'border-3 border-surface-5 text-surface-3 rounded-md  p-2',
                                            'w-[100%]',
                                            !editable
                                                ? ' cursor-text bg-surface-5 text-surface-3'
                                                : 'text-sm   ',
                                        )}
                                        value={curAccount?.stateId != null && curAccount?.stateId !== "" ? curAccount?.stateId : ''}
                                        onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                            setIsEmptyState(false);
                                            if (curAccount?.subdivisionId !== null && curAccount?.subdivisionId !== '') {
                                                setChangeField("stateId");
                                                setIsSavedResult(false);
                                                setStateId(e.target.value);
                                                setUpdatedAccountIndexList((prev: any) => [...prev, showAccount]);
                                                setConfirmationModal(true);
                                            } else {
                                                updateCertificateAccountField('stateId', e.target.value);
                                                getCountyByStateIdApi(e.target.value);
                                            }

                                        }}
                                        disabled={!editable}
                                    >
                                        <option value="">Select State</option>
                                        {stateList?.map((state: any) => (
                                            <option key={state.id} value={state.id}>
                                                {state.stateName}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">County</td>
                                <td>
                                    <select
                                        className={isEmptyCounty ? "border border-3 border-error-2 p-2 rounded-md text-surface-3 w-[100%]" : clsx(
                                            'border-3 border-surface-5 text-surface-3 rounded-md  p-2',
                                            'w-[100%]',
                                            !editable
                                                ? ' cursor-text bg-surface-5 text-surface-3'
                                                : 'text-sm',
                                        )}
                                        value={curAccount?.countyId != null && curAccount?.countyId !== "" ? curAccount?.countyId : ''}
                                        onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                            setIsEmptyCounty(false);
                                            if (curAccount?.subdivisionId !== null && curAccount?.subdivisionId !== '') {
                                                setCountyId(e.target.value);
                                                setChangeField("countyId");
                                                setUpdatedAccountIndexList((prev: any) => [...prev, showAccount]);
                                                setConfirmationModal(true);
                                            } else {
                                                updateCertificateAccountField('countyId', e.target.value)
                                            }
                                        }}
                                        disabled={!editable || curAccount?.stateId == null || curAccount?.stateId === ''}
                                    >
                                        <option value="">Select County</option>
                                        {Array.isArray(countyList.data) &&
                                            countyList.data.map((county: any) => (
                                                <option key={county.id} value={county.id}>
                                                    {county.countyName}
                                                </option>
                                            ))
                                        }
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">Zip</td>
                                <td>

                                    <InputField
                                        placeholder="..."
                                        value={curAccount?.zipCode || ""}
                                        type="text"
                                        disabled={!editable}
                                        hideLabel
                                        onChange={(e) => {
                                            updateCertificateAccountField('zipCode', e.target.value)

                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">Seller(s)</td>
                                <td>
                                    <InputField
                                        placeholder="..."
                                        value={curAccount?.sellers || ""}
                                        type="text"
                                        disabled={!editable}
                                        hideLabel
                                        onChange={(e) => {
                                            updateCertificateAccountField('sellers', e.target.value)

                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="pl-3">Buyer(s)</td>
                                <td>
                                    <InputField
                                        placeholder="..."
                                        value={curAccount?.buyers || ""}
                                        type="text"
                                        disabled={!editable}
                                        hideLabel
                                        onChange={(e) => {
                                            updateCertificateAccountField('buyers', e.target.value)

                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {confirmationModal && (
                <ConfirmationModal
                    title={"Warning"}
                    bodyMessage={
                        changeField === "stateId" ? (
                            <>
                                <p>Changing state will reset fee list and association notes.</p>
                                <p>Continue ?</p>
                            </>
                        ) : (
                            <>
                                <p>Changing county will reset fee list and association notes.</p>
                                <p>Continue ?</p>
                            </>
                        )
                    }
                    isLoading={disable}
                    onSubmit={updateData}
                    show={confirmationModal}
                    setShow={setConfirmationModal}
                    isHoa={true}
                />
            )}
        </>
    );
}